// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ql-editor{font-size:16px;font-family:\"Noto Sans\", Arial, Helvetica, sans-serif}.ql-tooltip{z-index:99999}\n", "",{"version":3,"sources":["quill.scss"],"names":[],"mappings":"AAAA,WACE,cAAe,CACf,qDAAsD,CACvD,YAGC,aAAc","file":"quill.scss","sourcesContent":[".ql-editor {\n  font-size: 16px;\n  font-family: \"Noto Sans\", Arial, Helvetica, sans-serif;\n}\n\n.ql-tooltip {\n  z-index: 99999;\n}\n"]}]);
// Exports
module.exports = exports;
